import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { Segment } from '../../../../../services/analytics-services/segment';
import { FUND_SHIPSURANCE_CLICK, CONFIRM_FUND_SHIPSURANCE_CLICK } from '../../../../../constants/analytics-events';

export const PageEvents = {
  FUND_SHIPSURANCE_CLICK,
  CONFIRM_FUND_SHIPSURANCE_CLICK,
};

export const useTrackEvent = (eventName, source = '') => {
  const planInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);

  return useCallback(
    (metadata = {}) => {
      const payload = {
        planCode: planInfo?.planCode,
        // The lift to convert a handful of tracking events off this flag would blow scope.
        // SPD-16505 to track final clean up of this.
        enablePaymentsAndSubscriptionSettings: true,
        ...metadata,
      };

      if (source) {
        payload.source = source;
      }

      Segment.trackEvent(eventName, payload);
    },
    [eventName, planInfo?.planCode, source],
  );
};
